export async function loadTags() {
    try {
        const { tags } = await this.api.getTags();
        if (Array.isArray(tags)) {
            this.populateTagsFilter(tags);
        }
    } catch (error) {
        console.error('Error loading tags:', error);
    }
}

export function populateTagsFilter(tags) {
    const tagsMenu = document.getElementById('tags-filter-menu');
    const loadingElement = document.getElementById('tags-filter-loading');

    if (!tagsMenu || !loadingElement) return;

    loadingElement.remove();

    tags.forEach((tag) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tags-filter-option w-full text-left px-3 py-2 hover:bg-gray-100';
        button.setAttribute('data-value', tag.name);
        button.innerHTML = `${tag.name} <span class="text-gray-400 float-right">(${tag.count})</span>`;
        tagsMenu.appendChild(button);
    });
}
